<template>
  <el-card>
    <el-form label-width="100px" label-position="left">
      <el-form-item label="项目名称">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="班组名称">
        {{ formData.teamName }}
      </el-form-item>
      <el-form-item label="开始日期">
        {{ formData.startDate }}
      </el-form-item>
      <el-form-item label="结束日期">
        {{ formData.endDate }}
      </el-form-item>
      <el-form-item label="合同总额">
        {{ formData.contractAmount }}
      </el-form-item>
      <el-form-item label="最低用工数">
        {{ formData.minWorkerNum }}人/{{ formData.minWorkerType === '1' ? '天' : '月' }}
      </el-form-item>
      <el-form-item label="状态">
        {{ formData.status === 0 ? '启用' : '禁用' }}
      </el-form-item>
      <el-form-item label="合同附件">
        <file-upload readonly disabled v-model="formData.fileList" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: 'details',
  components: {
    FileUpload
  },
  data () {
    return {
      formData: {
        teamLaborId: '', // 班组劳务包工ID
        teamId: '', // 班组ID
        projectId: '', // 项目ID
        startDate: '', // 劳务开始日期
        endDate: '', // 劳务结束日期
        contractAmount: '', // 合同金额
        dayAvgAmount: '', // 日平均金额
        minWorkerType: '', // 最低用工类型1天2月
        minWorkerNum: '', // 最低用工数
        status: '', // Integer	状态0启动1禁用
        fileList: [], // 附件列表
      }
    }
  },
  computed: {
    teamLaborId() {
      return this.$route.query.teamLaborId
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.laborManage.selectTeamLaborByTeamLaborId, {
        teamLaborId: this.teamLaborId
      }).then(res => {
        this.formData = res || {}
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
